import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import Portal from '../Portal';

const Modal = ({
  children,
  className,
  withPortal = false,
  onBackdropClick
}) => {
  const Components = React.useMemo(() => withPortal ? Portal : React.Fragment, [withPortal]);
  return /*#__PURE__*/React.createElement(Components, null, /*#__PURE__*/React.createElement("div", {
    onClick: onBackdropClick,
    className: classNames(styles.backdrop, styles.show, className)
  }, children));
};

export default Modal;